
// Vue reactivity
import { ref, reactive, defineComponent, watchEffect } from 'vue';

// icons
import { thumbsUpOutline, thumbsDownOutline, add, close } from 'ionicons/icons';

// components
import { IonHeader, IonToolbar, IonTitle, IonContent, IonFooter, IonSpinner, IonItem, IonLabel, IonIcon,
        IonThumbnail, IonAvatar, IonButtons, IonButton, IonInput, IonTextarea, modalController, loadingController, } from '@ionic/vue';

// API services
import PostService from '@/services/PostService';

import { utils } from '@/composables/utils';
import { useI18n } from 'vue-i18n';

export default defineComponent({
  name: 'PostModal',
  props: {
    editingPost: null,
  },
  components: { IonHeader, IonToolbar, IonTitle, IonContent, IonFooter,
                IonSpinner, IonItem, IonLabel, IonIcon,
                IonThumbnail, IonAvatar, IonButtons, IonButton, IonInput, IonTextarea },
  setup(props) {
    // 1. declare state variables (ref to make them reactive)
    const post = reactive({
      id: null,
      title: "",
      content: "",
      image: "",
    });
    const postImageFile = ref<any>(null);
    const isEditingPost = ref(false);

    if (props.editingPost) { // editing post
      isEditingPost.value = true;
      watchEffect(() => {
        const { id, title, content, image } = props.editingPost.value;
        post.id = id;
        post.title = title;
        post.content = content;
        post.image = image;
      })
    }

    // 2. fetch data from API and store data in state variables
    // TODO (for editing post)

    // methods or filters
    const { t } = useI18n();
    const { formatDate, presentToast } = utils();

    const closeModal = async (data: any = {}) => {
      await modalController.dismiss(data);
    };
    const onPostImageFileChange = (e: any) => {
      if (e.target.files && e.target.files[0]) {
        postImageFile.value = e.target.files[0];
        const reader = new FileReader();
        reader.onload = (e: any) => {
          post.image = e.target.result;
        }
        reader.readAsDataURL(postImageFile.value); // convert to base64 string and preview it
        e.srcElement.value = null;
      }
    }
    const clearUploadedPostImage = () => {
      post.image = "";
      postImageFile.value = null;
    }

    const createNewPost = async (title: string, content: string) => {
      const loading = await loadingController.create({});
      await loading.present();
      const res = await PostService.addNewPost(title, content, postImageFile.value);
      loading.dismiss();
      presentToast( t('PostPage.successPublishPost'), 2000 );
      closeModal({ newPostCreated: true });
    };

    const updatePost = async() => {
      const loading = await loadingController.create({});
      await loading.present();
      const originalImageLink = props.editingPost.value.image;
      const res = await PostService.updatePost(post.id, post.title, post.content, post.image, postImageFile.value, originalImageLink);
      loading.dismiss();
      presentToast( t('PostPage.successUpdatePost'), 2000 );
      closeModal();
    }

    // 3. return variables & methods to be used in template HTML
    return {
      t,

      // icons
      thumbsUpOutline, thumbsDownOutline, add, close,

      // variables
      post, postImageFile, isEditingPost,

      // methods
      formatDate, createNewPost, updatePost, closeModal,
      onPostImageFileChange, clearUploadedPostImage
    }
  }
});
